import styled from "styled-components";
import { CardView } from "@ann/web-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCardView = styled(CardView)`
  width: 100px;
  min-height: 328px;
  position: relative;
  padding: 32px;
`; 